/** Backend policy counts UTF-8 bytes, not JavaScript characters. */
export function validateNewPassword(value: FormDataEntryValue | null): string {
  const password = typeof value === 'string' ? value : '';
  const bytes = new TextEncoder().encode(password).byteLength;
  if (bytes < 12) throw new Error('Mật khẩu quá ngắn. Hãy dùng ít nhất 12 ký tự.');
  if (bytes > 1024) throw new Error('Mật khẩu vượt giới hạn 1024 byte. Hãy rút ngắn mật khẩu.');
  return password;
}
